import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  Overview,
  Cropping,
  // DataCollection,
  DataManagement,
  AgentSettings,
  Login,
} from '../../pages';
import './Content.scss';

const Content = () => {
  return (
    <div className="content">
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/overview" component={Overview} />
        <Route path="/cropping" component={Cropping} />
        {/* <Route path="/data-collection" component={DataCollection} /> */}
        <Route path="/data-management" component={DataManagement} />
        <Route path="/agent-settings" component={AgentSettings} />
        <Redirect from="/" to="/overview" />
      </Switch>
    </div>
  );
};

export default Content;
